import { render, staticRenderFns } from "./CoachConnectWithAthletes.vue?vue&type=template&id=4fc473ff&scoped=true&"
import script from "./CoachConnectWithAthletes.vue?vue&type=script&lang=ts&"
export * from "./CoachConnectWithAthletes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc473ff",
  null
  
)

export default component.exports